// extracted by css-extract-rspack-plugin
module.exports =  {"exercise":"Template35-tO5U__exercise","answer":"Template35-abCq__answer","answer-title":"Template35-se2E__answer-title","answer-text":"Template35-C_SG__answer-text"};